/**
 * @date: 2022-04-19
 * @author: Kevin Hsiau <khsiau@max.md>
 * @copy: (C) Copyright 2022 MaxMD Corporation, All Rights Reserved.
 */

import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import {Box} from "@mui/material";
import {columnLabel} from "../utils/column-aliases";

export default function ValidationRuleAutoComplete(props) {
    const { rules, setSelectedValue, selectedValue} = props;

    return (
        <Autocomplete
            disablePortal
            id="rules-select"
            options={rules}
            autoHighlight
            sx={{ marginBottom: 3}}
            // renderInput={(params) => <TextField {...params} label="Validation Rules" />}
            getOptionLabel={(rule) => `#${rule.ruleId} ${columnLabel(rule.primaryField)} / ${rule.errorName} / ${rule.name}`}
            isOptionEqualToValue={(option, value) => {
                if (option.ruleId === value.ruleId) {
                    return true;
                } else if (option.name === value.name) {
                    return true;
                } else if (option.errorName === value.errorName) {
                    return true;
                } else if (option.primaryField === value.primaryField) {
                    return true;
                } else {
                    return false;
                }
            }}
            renderOption={(props, option) => (
                <Box component='li' key={option.id} {...props} sx={{ backgroundColor: '#fafafa', fontSize: 12, color: '#444444'}}>
                    #{option.ruleId} {columnLabel(option.primaryField)} / {option.errorName} / {option.name}
                </Box>
            )}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label='Select a rule'
                />
            )}
            value={selectedValue}
            onChange={(_event, newValue) => {
                setSelectedValue(newValue);
            }}
        />
    );
}
